import { getCurrencySymbol } from 'src/utils/getCurrencySymbol'
import { displayAmountClean } from 'src/utils/displayAmountClean'
import type { FreeBetGroup } from './groupFreeBets'

export interface FreeBetGroupCardCopy {
  name: string
  value: string
  description: string
}

type Translate = (key: string, params?: Record<string, unknown>) => string

/**
 * Copy for a grouped free-bet card in the sidebar, e.g. name "10× Free bet",
 * value "$5", description stating its scope ("Usable on all games" vs
 * "Only on Plinko") so identical-value grants aren't confused. The noun comes
 * from the `Free bet` key so en-soc renders "Free play" (sweepstakes). Pure —
 * no JSX — so it can be unit-tested. `gameName` is the current game's name
 * (the sidebar only lists bets usable here, so a game-specific bet is this one).
 */
export function freeBetGroupCardCopy(
  group: FreeBetGroup,
  t: Translate,
  gameName?: string
): FreeBetGroupCardCopy {
  const value = `${getCurrencySymbol(group.currency)}${displayAmountClean(group.amount)}`
  const noun = t('Free bet')

  let description: string
  if (group.applicableGames.length === 0) {
    description = t('Usable on all games')
  } else if (gameName) {
    description = t('Only on {{game}}', { game: gameName })
  } else {
    description = t('Only on this game')
  }

  return {
    name: group.count > 1 ? `${group.count}× ${noun}` : noun,
    value,
    description
  }
}
